import { fmtDate } from "@/components/DatePicker";
import { formatPhone } from "@/lib/phone";

export function OfferLetterhead({ company, showLogo = true, logoOverride, offerDate, candidate, status }) {
  const logo = logoOverride || company?.logo_url;
  const accent = company?.color || "#2563EB";
  return (
    <header className="offer-letterhead" data-testid="offer-letterhead" style={{ borderBottom: `3px solid ${accent}` }}>
      <div className="flex items-start justify-between gap-6 pb-5">
        <div className="flex items-center gap-4 min-w-0">
          {showLogo && (logo ? <img src={logo} alt={company?.name} className="h-16 max-w-[220px] object-contain" data-testid="offer-logo" /> : company?.logo ? <span className="text-4xl" data-testid="offer-logo">{company.logo}</span> : null)}
          <div className="min-w-0">
            <div className="text-xl font-bold tracking-tight" style={{ color: accent }}>{company?.name}</div>
            {company?.address && <div className="text-xs text-slate-500">{company.address}</div>}
            <div className="text-xs text-slate-500">{[formatPhone(company?.phone), company?.website].filter(Boolean).join(" · ")}</div>
          </div>
        </div>
        <div className="text-right text-xs text-slate-500 shrink-0">
          <div className="uppercase tracking-[0.2em] font-semibold text-slate-400">Offer of Employment</div>
          {offerDate && <div className="mt-1 font-mono-num text-slate-700">{fmtDate(offerDate)}</div>}
          {status && <div className="mt-1 capitalize">{status === "accepted" ? "Signed" : status}</div>}
        </div>
      </div>
      {candidate?.name && (
        <div className="pt-4 text-sm text-slate-700">
          <div className="font-semibold">{candidate.name}</div>
          {candidate.address && <div>{candidate.address}</div>}
          <div className="text-slate-500">{[candidate.email, formatPhone(candidate.phone)].filter(Boolean).join(" · ")}</div>
        </div>
      )}
    </header>
  );
}

export function OfferPaper({ children, className = "" }) {
  return (
    <article data-testid="offer-paper" className={`offer-paper bg-white text-slate-900 rounded-xl border border-slate-200 shadow-sm mx-auto w-full max-w-[8.5in] px-8 sm:px-14 py-10 sm:py-14 font-serif leading-relaxed [&_p]:my-3 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:my-1 [&_h2]:font-sans [&_h2]:text-base [&_h2]:font-bold [&_h2]:mt-6 [&_strong]:font-semibold ${className}`}>
      {children}
    </article>
  );
}
